<div class="module-details-page">
  <div>
    <div *ngIf="!aboutTheModuleModus" fxLayout="row">
      <loi-back-link text="{{'Link_Back_To_Module_Overview_Page' | translate}}"
        (clicked)="backToOverview()"></loi-back-link>
    </div>
    <div class="module-code" *ngIf="aboutTheModuleModus">{{'Module_Details_Module_Code' | translate}}: {{moduleInfo ? moduleInfo.label : ''}}</div>
    <div class="module-detail-page-header">
      <div><h1>{{moduleInfo ? moduleInfo.title : ''}}</h1></div>
    </div>
  </div>
  <div fxLayout="row" class="page-content-columns">

    <!-- Left side -->
    <div fxFlex="auto" class="left-side">

      <div *ngIf="loading" id="loadingDiv" style="height:600px"></div>
      <div *ngIf="!loading">

        <div *ngIf="isImageUrlValid" class="module_details_image">
          <img #image src="{{imageUrl}}" class="module_details_image">
        </div>

        <div class="oer-description" [innerHTML]="oerDescription"></div>

        <!--Recommended prior knowledge-->
        <mat-accordion displayMode="flat" multi="true">
          <mat-expansion-panel class="accordion-panel" hideToggle expanded="true">
            <mat-expansion-panel-header class="accordion-header">
              <mat-panel-title class="accordion-title">
                <h3>{{'Module_Details_Recommended_Prior_Knowledge' | translate}}</h3>
              </mat-panel-title>
              <mat-icon svgIcon="expand_more" class="expand"></mat-icon>
            </mat-expansion-panel-header>
            <div class="accordion-content-row" [innerHTML]="oerPriorKnowledge"></div>
          </mat-expansion-panel>
        </mat-accordion>

        <!--Module Parts-->
        <module-parts-component *ngIf="serviceContract" [moduleId]="moduleId" [contractType]="contractType"></module-parts-component>

        <!--LearningGoalsMbo-->
        <mat-accordion *ngIf="oerLearningGoalsMbo != null" displayMode="flat" multi="true">
          <mat-expansion-panel class="accordion-panel" hideToggle expanded="true">
            <mat-expansion-panel-header class="accordion-header">
              <mat-panel-title class="accordion-title">
                <h3>{{'OERLearningGoalsMboAccordeonName' | translate}}</h3>
              </mat-panel-title>
              <mat-icon svgIcon="expand_more" class="expand"></mat-icon>
            </mat-expansion-panel-header>
            <div class="accordion-content-row" [innerHTML]="oerLearningGoalsMbo"></div>
          </mat-expansion-panel>
        </mat-accordion>

        <!--LearningGoals-->
        <mat-accordion *ngIf="oerLearningGoals != null || oerLearningGoalsCur != null" displayMode="flat" multi="true">
          <mat-expansion-panel class="accordion-panel" hideToggle expanded="true">
            <mat-expansion-panel-header class="accordion-header">
              <mat-panel-title class="accordion-title">
                <h3>{{'Module_Details_Learning_Goals' | translate}}</h3>
              </mat-panel-title>
              <mat-icon svgIcon="expand_more" class="expand"></mat-icon>
            </mat-expansion-panel-header>
            <div *ngIf="oerLearningGoals" class="accordion-content-row" [innerHTML]="oerLearningGoals"></div>
            <div *ngIf="oerLearningGoalsCur" class="accordion-content-row" [innerHTML]="oerLearningGoalsCur"></div>
          </mat-expansion-panel>
        </mat-accordion>

        <!--LearningOutcomes-->
        <mat-accordion *ngFor="let learningOutcomes of oerLearningOutcomes; let i = index" displayMode="flat" multi="true">
          <mat-expansion-panel class="accordion-panel" hideToggle expanded="true">
            <mat-expansion-panel-header class="accordion-header">
              <mat-panel-title class="accordion-title">
                <h3>{{'Module_Details_Learning_Outcome' | translate}} {{i + 1}}</h3>
              </mat-panel-title>
              <mat-icon svgIcon="expand_more" class="expand"></mat-icon>
            </mat-expansion-panel-header>
            <div class="accordion-content-row" [innerHTML]="learningOutcomes"></div>
          </mat-expansion-panel>
        </mat-accordion>

        <!--StandardExemptions-->
        <mat-accordion displayMode="flat" multi="true">
          <mat-expansion-panel class="accordion-panel" hideToggle expanded="true">
            <mat-expansion-panel-header class="accordion-header">
              <mat-panel-title class="accordion-title">
                <h3>{{'Module_Details_Standard_Exemptions' | translate}}</h3>
              </mat-panel-title>
              <mat-icon svgIcon="expand_more" class="expand"></mat-icon>
            </mat-expansion-panel-header>
            <div class="accordion-content-row">
              <p>{{ getExemptionInfo() | translate }}</p>
              <div *ngIf="hasExemptionRequirements() && isExemption()">
                <h4>{{ 'Module_Exemption_Subtitle' | translate }}</h4>
                <p>{{ 'Module_Exemption_Info' | translate }}</p>
                <p *ngFor="let exemption of exemptions" class="remove-margin-bottom marging-left">- {{ exemption }}</p>
              </div>
              <div *ngIf="isExemption()">
                <p class="margin-top">{{ 'Exemption_Submit_Request_Info_Before_Link' | translate }}</p>
                <div class="exemption-link-container">
                  <a [href]="exemptionUrl" target="_blank" class="buttonstyle">{{ 'Exemption_Submit_Request_Link' | translate}}</a>
                </div>
                <p class="margin-top remove-margin-bottom">{{ 'Exemption_Submit_Request_Info_After_Link1' | translate }}</p>
                <p>{{ 'Exemption_Submit_Request_Info_After_Link2' | translate }}</p>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>

    <!-- Right side -->
    <div *ngIf="!aboutTheModuleModus" fxFlex="298px">
      <div fxLayout="column" fxLayoutGap="25px">
        <div fxFlex="auto" class="rounded-box">
          <div><h3>{{'Module_Details_Module_Characteristics' | translate}}</h3></div>
          <div>
            <div fxLayout="row">
              <div fxFlex="80px">{{'Module_Details_Module_Code' | translate}}:</div>
              <div fxFlex="auto" class="right-aligned-item">{{module.externalCode}}</div>
            </div>
            <div fxLayout="row">
              <div fxFlex="80px">{{'Module_Details_Study_Effort' | translate}}:</div>
              <div fxFlex="auto" class="right-aligned-item">{{module.defaultCredits}} {{getDefaultCreditsUnit()}}</div>
            </div>
          </div>
          <div>
            <br />
            <button *ngIf="module.status == 1 && !activationInProgress" class="button" [ngClass]="disabledModuleActivation ? 'inactive' : ''"
             (click)="activateModuleClick()" [disabled]="disabledModuleActivation">
              {{'Module_Details_Activate_Now' | translate}}
            </button>
            <button *ngIf="module.status != 1 && !isExemptionOrUnavailable() && !activationInProgress" class="button" (click)="toWorkspaceClick()">
              {{'Module_Details_To_Module_Workspace' | translate}}
            </button>
            <div *ngIf="module.status == 3 && activationInProgress" fxLayout="row">
              <div fxFlex="2em">
                <mat-icon svgIcon="icon_information" class="exclamation-icon"></mat-icon>
              </div>
              <div fxFlex="auto">
                <div>
                  <div class="italic-text">{{'Module_Details_Activation_Is_Being_Processed' | translate}}</div>
                  <div>{{'Module_Details_Activation_Is_Being_Processed_Text' | translate}}</div>
                </div>
              </div>
            </div>
            <div *ngIf="isExemptionOrUnavailable()">
              {{moduleNotActivatableTextItem() | translate}}
              <div *ngIf="module.reason == 4">
                <div *ngFor="let prerequisite of module.modulePrerequisites">
                  - {{getModuleName(prerequisite)}}
                </div>
              </div>
            </div>
            <div class="paragraph-heading-blue-bold">{{'Module_Details_Do_You_Have_A_Question' | translate}}</div>
            <div [innerHTML]="'Module_Details_Read_About_Activating' | translate : modulesFaqLink"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
